import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, ExternalLink, FileDown, FileText } from 'lucide-react';

/**
 * Anteprima PDF inline (preventivi e contratti) con fallback
 * "apri in nuova scheda" e download per i browser mobile che
 * non renderizzano i PDF negli iframe (es. Safari iOS).
 * props: open, onOpenChange, title, pdfUrl (object URL), loading, filename
 */
export function PdfPreviewDialog({ open, onOpenChange, title, pdfUrl, loading, filename = 'documento.pdf' }) {
  // Revoca l'object URL alla chiusura per liberare memoria
  useEffect(() => {
    return () => { if (pdfUrl) setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000); };
  }, [pdfUrl]);

  const download = () => {
    if (!pdfUrl) return;
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[calc(100vw-1.5rem)] max-h-[95vh] flex flex-col p-4 sm:p-6" data-testid="pdf-preview-dialog">
        <DialogHeader className="shrink-0">
          <DialogTitle className="flex items-center gap-2 pr-8"><FileText className="size-4 text-primary" />{title || 'Anteprima documento'}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-[55vh] rounded-lg border overflow-hidden bg-muted/40 grid">
          {loading ? (
            <div className="place-self-center flex items-center gap-2 text-sm text-muted-foreground p-10">
              <Loader2 className="size-4 animate-spin" />Generazione anteprima in corso...
            </div>
          ) : pdfUrl ? (
            <iframe
              title="Anteprima PDF"
              src={`${pdfUrl}#toolbar=0&view=FitH`}
              className="w-full h-full min-h-[55vh]"
              data-testid="pdf-preview-iframe"
            />
          ) : (
            <div className="place-self-center text-sm text-muted-foreground p-10">Anteprima non disponibile</div>
          )}
        </div>
        <DialogFooter className="shrink-0 flex-row justify-end gap-2 flex-wrap">
          <Button variant="outline" size="sm" onClick={() => pdfUrl && window.open(pdfUrl, '_blank')} disabled={!pdfUrl} data-testid="pdf-preview-open-tab">
            <ExternalLink className="size-4 mr-2" />Apri in nuova scheda
          </Button>
          <Button size="sm" onClick={download} disabled={!pdfUrl} data-testid="pdf-preview-download">
            <FileDown className="size-4 mr-2" />Scarica PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
